{
  "name": "multipanel",
  "version": "26.10.24",
  "scripts": {
    "ng": "ng",
    "start": "systemd-run --user --scope -p MemoryHigh=5G -p MemoryMax=6G -p MemorySwapMax=0 -- ng serve",
    "start:raw": "ng serve",
    "start:low": "NG_BUILD_MAX_WORKERS=2 systemd-run --user --scope -p MemoryHigh=4G -p MemoryMax=5G -p MemorySwapMax=0 -- ng serve",
    "start:fast": "NG_BUILD_TYPE_CHECK=0 systemd-run --user --scope -p MemoryHigh=5G -p MemoryMax=6G -p MemorySwapMax=0 -- ng serve",
    "build": "ng build",
    "test": "ng test --watch=false",
    "watch": "ng build --watch --configuration development",
    "format": "prettier --write \"src/**/*.{html,scss,ts}\"",
    "format:check": "prettier --check \"src/**/*.{html,scss,ts}\"",
    "new-tag": "node scripts/new-tag.js",
    "new-tag-hotfix": "node scripts/new-tag-hotfix.js",
    "homologation-deploy": "node scripts/deploy.js multipanel homologation",
    "production-deploy": "node scripts/deploy.js multipanel production",
    "customers:homologation-deploy": "node scripts/deploy.js customers homologation",
    "customers:production-deploy": "node scripts/deploy.js customers production",
    "vendor:homologation-deploy": "node scripts/deploy.js vendor homologation",
    "vendor:production-deploy": "node scripts/deploy.js vendor production",
    "quotes:homologation-deploy": "node scripts/deploy.js quotes homologation",
    "quotes:production-deploy": "node scripts/deploy.js quotes production",
    "ticket:homologation-deploy": "node scripts/deploy.js ticketcenter homologation",
    "ticket:production-deploy": "node scripts/deploy.js ticketcenter production",
    "integrator:homologation-deploy": "node scripts/deploy.js integrator homologation",
    "integrator:production-deploy": "node scripts/deploy.js integrator production",
    "v3ndor:homologation-deploy": "node scripts/deploy.js v3ndor homologation",
    "v3ndor:production-deploy": "node scripts/deploy.js v3ndor production",
    "all:homologation-deploy": "node scripts/deploy.js all homologation",
    "all:production-deploy": "node scripts/deploy.js all production",
    "homologation-deploy-fast": "node scripts/deploy-homologation-fast.js multipanel",
    "customers:homologation-deploy-fast": "node scripts/deploy-homologation-fast.js customers",
    "vendor:homologation-deploy-fast": "node scripts/deploy-homologation-fast.js vendor",
    "quotes:homologation-deploy-fast": "node scripts/deploy-homologation-fast.js quotes",
    "ticket:homologation-deploy-fast": "node scripts/deploy-homologation-fast.js ticketcenter",
    "integrator:homologation-deploy-fast": "node scripts/deploy-homologation-fast.js integrator",
    "v3ndor:homologation-deploy-fast": "node scripts/deploy-homologation-fast.js v3ndor",
    "all:homologation-deploy-fast": "node scripts/deploy-homologation-fast.js all",
    "test:morpheus": "vitest run --config vitest.morpheus.config.mts",
    "test:crm-deals": "vitest run --config vitest.crm-deals.config.mts",
    "test:utils": "vitest run --config vitest.utils.config.mts",
    "test:billing": "vitest run --config vitest.billing.config.mts",
    "test:contracts": "vitest run --config vitest.contracts.config.mts",
    "test:item-bulk": "vitest run --config vitest.item-bulk.config.mts",
    "test:ai": "vitest run --config vitest.ai.config.mts",
    "test:customer-bulk": "vitest run --config vitest.customer-bulk.config.mts"
  },
  "private": true,
  "dependencies": {
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "^20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/animations": "^21.0.6",
    "@angular/cdk": "^21.0.5",
    "@angular/common": "^21.0.6",
    "@angular/compiler": "^21.0.6",
    "@angular/core": "^21.0.6",
    "@angular/fire": "^21.0.0-rc.0",
    "@angular/forms": "^21.0.6",
    "@angular/platform-browser": "^21.0.6",
    "@angular/platform-browser-dynamic": "^21.0.6",
    "@angular/router": "^21.0.6",
    "@maskito/angular": "^5.2.2",
    "@maskito/core": "^5.2.2",
    "@maskito/kit": "^5.2.2",
    "@ng-select/ng-select": "^21.1.3",
    "@primeuix/themes": "^2.0.3",
    "@sentry/angular": "^10.32.1",
    "@sentry/cli": "^2.58.4",
    "@teorema/patron": "git+ssh://git@altssh.bitbucket.org:443/teoremaweb/patron-dist.git#master",
    "@types/uuid": "^10.0.0",
    "angularx-qrcode": "^21.0.4",
    "axios": "^1.13.2",
    "bootstrap-icons": "^1.13.1",
    "brace": "^0.11.1",
    "chart.js": "^4.4.4",
    "d3-funnel": "^2.1.1",
    "docx-preview": "^0.4.0",
    "file-saver": "^2.0.5",
    "firebase": "10.3.1",
    "highlight.js": "^11.11.1",
    "jspdf": "^3.0.1",
    "jspdf-autotable": "^5.0.2",
    "jszip": "^3.10.1",
    "laravel-echo": "^2.3.4",
    "leaflet": "^1.9.4",
    "marked": "^17.0.0",
    "minisearch": "^7.2.0",
    "moment": "^2.30.1",
    "ng2-charts": "^8.0.0",
    "ng2-currency-mask": "13.0.3",
    "ngx-ace-wrapper": "^14.0.0",
    "ngx-color-picker": "^17.0.0",
    "ngx-highlightjs": "^10.0.0",
    "ngx-markdown": "^21.0.1",
    "ngx-mask": "16.3.9",
    "ngx-quill": "^30.0.1",
    "ngx-scrollbar": "^19.1.0",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.3",
    "pusher-js": "^8.5.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "^0.15.1"
  },
  "overrides": {
    "@teorema/patron": {
      "bootstrap-icons": "$bootstrap-icons"
    }
  },
  "devDependencies": {
    "@angular/build": "^21.0.4",
    "@angular/cli": "~21.0.4",
    "@angular/compiler-cli": "^21.0.6",
    "@types/d3": "^7.4.3",
    "@types/file-saver": "^2.0.5",
    "@types/leaflet": "^1.9.3",
    "d3": "^7.9.0",
    "fake-indexeddb": "^6.2.5",
    "fs-extra": "^11.1.1",
    "jsdom": "^28.1.0",
    "juice": "^11.0.3",
    "node-fetch": "^2.7.0",
    "prettier": "^3.7.4",
    "readline-sync": "^1.4.10",
    "shelljs": "^0.8.5",
    "typescript": "~5.9.3",
    "vitest": "^4.0.18"
  }
}